module.exports = __webpack_public_path__ + "img/flexy.49e50135.png";